<template>
  <div class="about">
    <div id="myCar">
      <three-rotate imgsPath="rotateImg/pro1" :totalNum="61"></three-rotate>
    </div>
  </div>
</template>
<script>
import ThreeDRotate from "../components/3dRotate/index";
export default {
  mounted() {},
  components: {
    "three-rotate": ThreeDRotate
  }
};
</script>
<style lang="less">
#myCar {
  width: 1000px;
  height: 560px;
  margin: 0 auto;
}
</style>
